import {NativeDateAdapter} from '@angular/material/core';
import {Injectable} from '@angular/core';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  override getFirstDayOfWeek(): number {
    return 1;
  }

  override getDayOfWeekNames(): string[] {
    return ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
  }

  override getMonthNames(): string[] {
    return ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
  }

  override format(date: Date): string {
    const day = this.convertToTwoSymbols(date.getDate());
    const month = this.convertToTwoSymbols(date.getMonth() + 1);

    return `${day}.${month}.${date.getFullYear()}`;
  }

  private convertToTwoSymbols(value: number): string {
    const stringValue = String(value);
    const valueLength = stringValue.length;

    return valueLength > 1 ? stringValue : `0${stringValue}`;
  }

  override parse(value: any): Date | null {
    if (!value) {
      return null;
    }

    if (typeof value === 'string') {
      const parts = value.split('.');
      if (parts.length === 3) {
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        let year = parseInt(parts[2], 10);

        if (year < 100) {
          year += 2000;
        }

        return new Date(year, month, day);
      }
    }

    return super.parse(value);
  }
}
